function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//  @jsx h
import { toArray } from '@nrk/dh-utils';
import { h } from 'preact';
import PureComponent from '../lib/preact-pure-component';

class ViewportIntersections extends PureComponent {
  constructor(props) {
    super();

    _defineProperty(this, "elm", void 0);

    _defineProperty(this, "intersectionObserver", void 0);

    this.state = {
      intersections: props.children.map((child, idx) => {
        return {
          isIntersecting: false,
          ratio: null
        };
      })
    };
  }

  createIntersectionObserver() {
    const _this$props = this.props,
          onChange = _this$props.onChange,
          onEnter = _this$props.onEnter,
          onLeave = _this$props.onLeave,
          rootMargin = _this$props.rootMargin,
          threshold = _this$props.threshold,
          root = _this$props.root;
    const childNodes = toArray(this.elm.childNodes);
    this.intersectionObserver = new IntersectionObserver(entries => {
      const intersections = this.state.intersections.slice(0);
      entries.forEach(entry => {
        const idx = childNodes.indexOf(entry.target);
        const prevIntersection = intersections[idx];
        intersections.splice(idx, 1, {
          isIntersecting: entry.isIntersecting,
          ratio: entry.intersectionRatio
        });

        if (onEnter && !prevIntersection.isIntersecting && entry.isIntersecting) {
          onEnter(entry, idx);
        }

        if (onLeave && prevIntersection.isIntersecting && !entry.isIntersecting) {
          onLeave(entry, idx);
        }
      });
      this.setState({
        intersections
      });

      if (onChange) {
        onChange(intersections);
      }
    }, {
      root: root === 'self' ? this.elm : root,
      rootMargin: rootMargin || '0px 0px 0px 0px',
      threshold: threshold || 1.0
    });
    childNodes.forEach(childElm => this.intersectionObserver.observe(childElm));
  }

  componentDidMount() {
    this.createIntersectionObserver();
  }

  componentWillUnmount() {
    this.intersectionObserver.disconnect();
  }

  componentDidUpdate(previousProps) {
    if (this.props.rootMargin !== previousProps.rootMargin) {
      this.intersectionObserver.disconnect();
      this.createIntersectionObserver();
    }
  }

  render() {
    const _this$props2 = this.props,
          className = _this$props2.className,
          children = _this$props2.children,
          style = _this$props2.style;
    return h("div", {
      ref: elm => this.elm = elm,
      className: className,
      style: style
    }, children);
  }

}

export default ViewportIntersections;